export const EXPENSES_TRACKER_REGISTER_URL = "/auth/signup";
export const EXPENSES_TRACKER_LOGIN_URL = "/auth/signin";
export const EXPENSES_TRACKER_LOGOUT_URL = "/auth/logout";
export const EXPENSES_TRACKER_LOGOUT_ALL_URL = "/auth/logout-all";
export const EXPENSES_TRACKER_REFRESH_TOKEN_URL = "/auth/refresh";
export const EXPENSES_TRACKER_VERIFY_EMAIL_URL = "/auth/verify-email";
export const EXPENSES_TRACKER_RESEND_VERIFICATION_EMAIL_URL = "/auth/resend-verification";
export const PASSWORD_RESET_REQUEST_URL = "/auth/password-reset/request";
export const PASSWORD_RESET_RESET_URL = "/auth/password-reset/reset";
export const EXPENSES_TRACKER_USER_PROFILE_URL = "/users/profile";
export const EXPENSES_TRACKER_USER_PROFILE_SETTINGS_URL = "/users/profile/settings";
export const USER_PASSWORD_URL = "/users/password";
export const USER_EMAIL_CHANGE_URL = "/users/email/change";
export const USER_EMAIL_CHANGE_CANCEL_URL = "/users/email/change/cancel";
export const USER_EMAIL_VERIFY_URL = "/users/email/verify";
export const USER_EMAIL_CHANGE_COMPLETE_URL = "/users/email/change/complete";
export const USER_EMAIL_CHANGE_STATUS_URL = "/users/email/change/status";
export const EXPENSES_URL = "/expenses";
export const INCOMES_URL = "/incomes";
export const CATEGORIES_URL = "/categories";
export const CATEGORY_TYPE_QUERY_PARAM = "type";
export const CATEGORY_INCLUDE_INACTIVE_PARAM = "includeInactive";
export const CATEGORY_FALLBACK_QUERY_PARAM = "fallback";
export const EXPENSE_CATEGORIES_TYPE = "expense";
export const INCOME_CATEGORIES_TYPE = "income";
export const START_DATE_QUERY_PARAM = "startDate";
export const END_DATE_QUERY_PARAM = "endDate";
export const CATEGORY_ID_FILTER_PARAM = "categoryId";
export const REPORTS_ENDPOINT = "/reports";
export const ALL_TIME_REPORTS_ENDPOINT = REPORTS_ENDPOINT + "/allTime";
export const CONTACT_URL = "/contact";
